module.exports = __webpack_public_path__ + "static/img/uaectlogo - Copy.36e70a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uaectlogo - Copy.png
// module id = eFO+
// module chunks = 0